import React, { useState, useEffect, useCallback, useMemo } from 'react';
import "./SideBar.css";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Tab, Tabs, AccordionDetails, AccordionSummary, Accordion } from '@mui/material';
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import  { FilterTree } from "../../index"
import scort from '../../../../assets/Images/brands/scort.png';
import queclink from '../../../../assets/Images/brands/Queclink.png';
import ruptela from '../../../../assets/Images/brands/ruptela.png';
import voss from '../../../../assets/Images/brands/voss.png';


const SideBar = React.memo(({ handleSidebar, url, tree, setTree, searchQuery, brandData, setBrandData, brandSelected,setBrandSelected, setSearchQuery,
    loading, filtersData, addNode, updateNode, removeNode, selectedItems, setSelectedItems }) => {

        const [showAll, setShowAll] = useState(false); 
        const brandsdata = filtersData?.brands || [];
        const labels = filtersData?.labels || [];



        

        useEffect(() => {
          setBrandData(brandsdata);
        }, [brandsdata]);
      
        const toggleShowAll = () => setShowAll((prev) => !prev);


        const [sliderValues, setSliderValues] = useState({});

        const handleSliderChange = useCallback((key, path, newRange) => {
          setSliderValues(prev => ({
            ...prev,
            [key]: { path, range: newRange },
          }));
        }, []);


        // useEffect(() => {
        //   setTree({});
        //   setSelectedItems({});
        // }, [brandSelected]);


        
        // Modify handleResetAll to also reset expandedAccordions
        const handleResetAll = () => {
          setSelectedItems({});
          setBrandSelected([]);
          setSearchQuery('');
          setTree({});
        };
        
        // In handleResetFilter, reset the expanded state for the specific accordion
        const handleResetFilter = (key, path) => {
          setSelectedItems(prev => {
            const newItems = { ...prev };
            delete newItems[key];
            return newItems;
          });
          const newTree = { ...tree };
          // Correct the path by including the filter's key
          removeNode(newTree, [...path, { key }]);
          setTree(newTree);
        };
     
    const [tabValue, setTabValue] = useState(0);
    const [expandedAccordions, setExpandedAccordions] = useState({});

    const handleChange = (event, newValue) => setTabValue(newValue);

    const toggleAccordion = useCallback((field_name, is_open) => {
        const accordionElement = document.querySelector(`[data-field-name="${field_name}"]`);
        setExpandedAccordions((prev) => {
            const isCurrentlyOpen = prev[field_name] ?? is_open;
            const isOpen = !isCurrentlyOpen;

            if (accordionElement) {
                accordionElement.classList.toggle('opened', isOpen);
                accordionElement.classList.toggle('closed', !isOpen);
            }
            return {
                ...prev,
                [field_name]: isOpen,
            };
        });
    }, []);

   

    const handleBrandClick = (brand) => {
      setBrandSelected((prev) => {
        const isSelected = prev.includes(brand);
        return isSelected 
          ? prev.filter((b) => b !== brand)
          : [...prev, brand];
      });
      // Force a state update by creating a new object reference
    
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };


    const pathExists = (fullPath) => {
        let current = tree;
        for (const item of fullPath) {
            const key = item.key;
            if (!current[key]) {
                // If any part of the path does not exist, return false
                return false;
            }
            current = current[key];
        }
        return true; // All parts of the path exist in the tree
    };


    const handleAddNode = useCallback(
      (path, nodeData) => {
        const newTree = { ...tree };
        addNode(newTree, path, nodeData);
        setTree(newTree);
      },
      [addNode, updateNode, removeNode]
    );
    
    const handleUpdateNode = useCallback(
      (path, nodeData, nodeName) => {
        const newTree = { ...tree };
        updateNode(newTree, path, nodeData, nodeName);
        setTree(newTree);
      },
      [addNode, updateNode, removeNode]
    );
    
    const handleRemoveNode = useCallback(
      (path) => {
        const newTree = { ...tree };
        removeNode(newTree, path);
        setTree(newTree);
      },
      [addNode, updateNode, removeNode]
    );



    
  



    return (

      <div 
        className="products-sidebar"
        style={{ position: `${showAll ? 'relative' : ''}`}}
      >
        {
          showAll && (
            <div 
              className="products-sidebar-title-container"
              style={{ 
                position: 'sticky', 
                top: '-20px',
                paddingTop: '10px',
                background: '#fff',
                zIndex: '111111',
                width: '104%'
              }} 
            >
              <div className="products-sidebar-title">Filter in Tracking Devices</div>
              <button 
                onClick={handleResetAll}
                className="reset-all-btn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M9.66167 1.66458C9.13738 1.13683 8.51384 0.718044 7.82697 0.432356C7.1401 0.146668 6.40349 -0.000272566 5.65958 3.79553e-07C2.52875 3.79553e-07 0 2.53583 0 5.66667C0 8.7975 2.52875 11.3333 5.65958 11.3333C8.30167 11.3333 10.5046 9.52708 11.135 7.08333H9.66167C9.36988 7.91174 8.8282 8.62918 8.11137 9.13668C7.39454 9.64417 6.53788 9.9167 5.65958 9.91667C3.315 9.91667 1.40958 8.01125 1.40958 5.66667C1.40958 3.32208 3.315 1.41667 5.65958 1.41667C6.83542 1.41667 7.88375 1.90542 8.64875 2.6775L6.36792 4.95833H11.3263V3.79553e-07L9.66167 1.66458Z" fill="#239DAB"/>
                </svg>
                Reset 
              </button>
              <div className="hide-sidebar" onClick={handleSidebar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 50 50"
                >
                  <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
                </svg>
              </div>
            </div>
          )
        }
        <div 
          className="products-sidebar-filter"
          style={{ position: `${showAll ? 'relative' : 'sticky'}`}} 
        >
          {
              showAll ? (
                <div className='d-none'></div>
              ) : (
                <div 
                className="products-sidebar-title-container"
                >
                  <div className="products-sidebar-title">Filter in Tracking Devices</div>
                  <button 
                    onClick={handleResetAll}
                    className="reset-all-btn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M9.66167 1.66458C9.13738 1.13683 8.51384 0.718044 7.82697 0.432356C7.1401 0.146668 6.40349 -0.000272566 5.65958 3.79553e-07C2.52875 3.79553e-07 0 2.53583 0 5.66667C0 8.7975 2.52875 11.3333 5.65958 11.3333C8.30167 11.3333 10.5046 9.52708 11.135 7.08333H9.66167C9.36988 7.91174 8.8282 8.62918 8.11137 9.13668C7.39454 9.64417 6.53788 9.9167 5.65958 9.91667C3.315 9.91667 1.40958 8.01125 1.40958 5.66667C1.40958 3.32208 3.315 1.41667 5.65958 1.41667C6.83542 1.41667 7.88375 1.90542 8.64875 2.6775L6.36792 4.95833H11.3263V3.79553e-07L9.66167 1.66458Z" fill="#239DAB"/>
                    </svg>
                    Reset 
                  </button>
                  <div className="hide-sidebar" onClick={handleSidebar}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 50 50"
                    >
                      <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
                    </svg>
                  </div>
                </div>
              )
          }
         
          <div className="products-sidebar-search">
            <label className="products-sidebar-label">Search</label>
            <input
              type="search"
              className="products-sidebar-input"
              placeholder="Search"
              onChange={handleSearchChange}
              value={searchQuery}
            />
          </div>

          <div className="">
      <Accordion className="products-sidebar-accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="products-sidebar-accordion-icon" />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="products-sidebar-accordion-content product-sidebar-brand"
        >
          Brand
        </AccordionSummary>
        <AccordionDetails className="products-sidebar-accordion-details">
          <Row>
            {(showAll ? brandData : brandData.slice(0, 3)).map((item, index) => (
              <Col
                xs={12}
                sm= {6}
                md={4}
                lg={4}
             
                key={index}
                onClick={() => handleBrandClick(item.brand)}
                className={`products-sidebar-accordion-brand ${
                    brandSelected.includes(item.brand) ? "selected" : ""
                }`}
              >
                <div className="products-sidebar-accordion-brand-content">
                  <img
                    src={`${url}${item.image}`}
                    className="products-sidebar-accordion-brand-img"
                    alt={item.brand}
                  />
                </div>
                <div className="products-sidebar-accordion-brand-title">
                  {item.brand}
                </div>
              </Col>
            ))}
          </Row>
          {brandData.length > 3 && (
            <div className="products-sidebar-accordion-show-more">
              <div  onClick={toggleShowAll} className="show-more">
                {showAll ? "Show Less" : "Show More"}
              </div>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>

          <div className="products-sidebar-btns">
            <Box>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="product specifications tabs"
                className="no-shadow"
                TabIndicatorProps={{ style: { backgroundColor: "#239DAB" } }}
              >
                <Tab
                  className="products-sidebar-btn"
                  label="Technical Specifications"
                  sx={{ "&.Mui-selected": { color: "#239DAB" } }}
                />
                <Tab
                  className="products-sidebar-btn"
                  label="Features"
                  sx={{ "&.Mui-selected": { color: "#239DAB" } }}
                />
              </Tabs>
            </Box>
          </div>
        </div>
        {loading ? (
          <>
            <div className="product-des">
              <Skeleton count={6} />
            </div>
          </>
        ) : (
          <FilterTree
            data={tabValue === 0 ? filtersData?.specifications : filtersData?.features}
            parent={tabValue === 0 ? [{ key: 'specifications' }] : [{ key: 'features' }]}

            /* inject every helper/state the tree needs */
            tree={tree}
            expandedAccordions={expandedAccordions}
            toggleAccordion={toggleAccordion}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            handleAddNode={handleAddNode}
            handleUpdateNode={handleUpdateNode}
            handleRemoveNode={handleRemoveNode}
            handleResetFilter={handleResetFilter}
            labels={labels}
            pathExists={pathExists}
          />
        )}
      </div>
    );

});

export default SideBar;

